/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Account_N_Technical__Answer_5Inputs */

const en_help_center__account_n_technical__answer_5 = /** @type {(inputs: Help_Center__Account_N_Technical__Answer_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your current bid balance is always visible on the right side of the bidpage.  (when logged in and participated in a battle). You can also view detailed bid history on the right side of the bidpage, purchases and usage in your Account Dashboard under "Billing."`)
};

/**
* | output |
* | --- |
* | "Your current bid balance is always visible on the right side of the bidpage. (when logged in and participated in a battle). You can also view detailed bid hi..." |
*
* @param {Help_Center__Account_N_Technical__Answer_5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__account_n_technical__answer_5 = /** @type {((inputs?: Help_Center__Account_N_Technical__Answer_5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Account_N_Technical__Answer_5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__account_n_technical__answer_5(inputs)
});